import { router, usePage } from "@inertiajs/react";
import { useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { pathOnly } from "@/lib/navigation";

export function RouteAccessibility() {
  const { t } = useTranslation();
  const { component } = usePage();
  useLayoutEffect(() => {
    const main = document.getElementById("main-content");
    if (!main) return;
    main.dataset.pageComponent = component;
    return () => {
      delete main.dataset.pageComponent;
    };
  });
  useEffect(() => {
    let path = pathOnly(window.location.pathname);
    let frame = 0;
    const stop = router.on("navigate", (event) => {
      const next = pathOnly(event.detail.page.url);
      if (next === path) return;
      path = next;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const main = document.getElementById("main-content");
        // Explicit form autofocus remains useful on focused creation/edit pages.
        const focused = document.activeElement;
        if (
          main?.contains(focused) &&
          focused?.matches("input,select,textarea,[role=combobox]")
        )
          return;
        main?.focus({ preventScroll: true });
      });
    });
    return () => {
      stop();
      cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <a
      href="#main-content"
      onClick={(event) => {
        const main = document.getElementById("main-content");
        if (main) {
          event.preventDefault();
          main.focus();
        }
      }}
      className="sr-only left-4 top-4 z-50 rounded-md bg-background p-3 text-foreground shadow-sm focus:not-sr-only focus:fixed focus:ring-2 focus:ring-ring"
    >
      {t("navigation.skip")}
    </a>
  );
}
